import styled from 'styled-components'

export const CheckboxLabel = styled.div`
  font-size: 14px;
`